module.exports = __webpack_public_path__ + "static/hokkien for beginners-d4e72a86de95243f1890e4b1075983cd.wav";